import React, { useEffect, useState } from 'react';
import useEmblaCarousel from "embla-carousel-react";
import BannerOddsOverlay from './BannerOddsOverlay';
import BannerOverlay from './BannerOverlay';
import { getConfiguration } from '../../data/utils/configuration';


export default function Carousel(props) {
    const [emblaRef, emblaApi] = useEmblaCarousel({
        loop: true,
        skipSnaps: false
    });
    const [selected, setSelected] = useState(0);
    const conf = getConfiguration();

    const SLIDER_INTERVAL = conf.iwh ? 5000 : 8000;

    useEffect(() => {
        let interval = null;

        function scrollNext() {
            clearInterval(interval);
            interval = setInterval(() => {
                emblaApi.scrollNext();
                setSelected(emblaApi.selectedScrollSnap());
            }, SLIDER_INTERVAL);
        }

        if (emblaApi) {
            scrollNext();
            emblaApi.on('select', () => {
                setSelected(emblaApi.selectedScrollSnap());
                scrollNext();
            });
        }

        return () => {
            clearInterval(interval);
        };
    }, [emblaApi]);

    const banners = props.banners;
    const currentBanner = banners[selected];

    return (
        <div className="embla rounded-lg" ref={emblaRef}>
            <div className="embla__container h-[140px] rounded-lg">
                {banners.map((banner, i) =>
                    <a key={i} href={banner.url} className="embla__slide w-full h-full rounded-lg">
                        <img src={banner.imageUrl} alt={''} className="h-full rounded-lg" />
                    </a>
                )}
            </div>
            <div className="absolute bottom-0 left-0 right-0 flex flex-col">
                {banners.length > 1 &&
                    <div className="h-4 flex items-center justify-center">
                        {banners.map((banner, i) =>
                            <span key={i} className={"h-1 w-3 mr-1 last:mr-0 rounded-full " + (selected === i ? 'bg-accent-5' : 'bg-contrast-5 opacity-340')}></span>
                        )}
                    </div>
                }
                {currentBanner.avvData?.bet != null ?
                    <BannerOddsOverlay data={currentBanner.avvData} />
                    :
                    currentBanner.text?.length > 0 &&
                    <BannerOverlay text={currentBanner.text} />
                }
            </div>
        </div>
    );
}
